// Shared by App.js (redeems a pending gift after sign-in) and pages/RedeemPage.
// Lives here so App.js can read the key without importing the whole page.
export const PENDING_GIFT_KEY = "pixley_pending_gift_token";
